<template>
  <div>
    <Header />
    <AboutUs />
  </div>
</template>
<script>
import Header from "./../AboutUs/header";
import AboutUs from "./../AboutUs/aboutUs";
export default {
  components: {
    Header,
    AboutUs
  },
  data() {
    return {};
  }
};
</script>